import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppStateRoot } from './app.model';
import { APP_FEATURE_KEY } from './app.reducer';

export const getAppState = createFeatureSelector<AppStateRoot>(APP_FEATURE_KEY);

export const getDetailsLoaded = createSelector(
  getAppState,
  (state) => state.detailsLoaded,
);

export const getDetailsError = createSelector(
  getAppState,
  (state) => state.detailsError,
);

export const getAgencyListError = createSelector(
  getAppState,
  (state) => state.agencyListError,
);

export const getDownloadError = createSelector(
  getAppState,
  (state) => state.downloadError,
);

export const getAdditionalDetailCode = createSelector(
  getAppState,
  (state) => state.additionalDetailCode,
);

const getAgencyList = createSelector(getAppState, (state) => state.agencyList);

export const getAgencyResponse = createSelector(
  getAppState,
  (state) => state.agencyResponse,
);

const getIsPostAffirmFailed = createSelector(
  getAppState,
  (state) => state.isPostAffirmFailed,
);
const getIsGetAgencyListFailed = createSelector(
  getAppState,
  (state) => state.isGetAgencyListFailed,
);
const getAffirmResponse = createSelector(
  getAppState,
  (state) => state.affirmResponse,
);

export const appStateQuery = {
  getDetailsLoaded,
  getDetailsError,
  getDownloadError,
  getAdditionalDetailCode,
  getAgencyList,
  getIsPostAffirmFailed,
  getAffirmResponse,
  getAgencyResponse,
  getIsGetAgencyListFailed,
  getAgencyListError,
};
